import { StyleSheet } from 'aphrodite/no-important';

import colors from '../../identity/colors';
import typeContent from '../../identity/type';
import screens from '../../identity/screenSizes';
import spacing from '../../identity/spacing';

export default StyleSheet.create({
  container: {
    backgroundColor: colors.BLUE_PRIMARY,
    padding: spacing.DESKTOP_T_R_L,
    paddingBottom: '120px',

    [screens.TABLET]: { padding: spacing.MOBILE_V_H },
    [screens.DESKTOP_HD]: { padding: '132px 66px' },
    [screens.MOBILE]: { padding: '108px 16px' },

  },

  introP: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'no-wrap',
    marginLeft: '32%',

    [screens.TABLET]: { margin: 0 },

  },

  columns: {
    display: 'flex',
    marginLeft: '32%',
    maxWidth: '900px',

    [screens.TABLET]: { marginLeft: 0 },
    [screens.MOBILE]: { flexDirection: 'column', marginLeft: 0 }, 
  },

  intro: {
    color: colors.WHITE,
    margin: '0 0 60px 0',
    ...spacing.M_B_L,
    maxWidth: '825px',
    ...typeContent.H3,

  },

  titles: {
    color: colors.WHITE,
    ...typeContent.H5,
    fontWeight: 500,
  },

  paragraphs: {
    ...typeContent.SMALL,
    fontWeight: typeContent.H3.fontWeight,
    color: colors.WHITE,
    width: '70%',

    [screens.MOBILE]: { width: '100%' }, 
  },


});



// WEBPACK FOOTER //
// ./src/components/Callout/style.js